import React, { useEffect, useState } from 'react';
import { Col, Container, Modal, Row } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Image from '../../components/Image/Image';
import NavbarComponent from '../../components/NavbarComponent/NavbarComponent';
import * as CONSTANT from '../../constants';
import { useStoreLocation } from '../../context/StoreLocation';
import SignUpButton from '../AccountStatus/SignUpButton';
import UserName from '../AccountStatus/UserName';
import CartModal from '../Cart/CartModal/CartModal';
import { LocationInfoModal } from '../LocationInfo/LocationInfoModal';
import styleClasses from './Header.module.scss';
import { useAppSelector, useAppDispatch } from '../../redux/store/store';
import { setShowCart } from '../../redux/slices/cartSlice';
import OrderType from '../ItemGrid/OrderType';
import Livetracking from '../LiveTracking/Livetracking';
import TagManager from 'react-gtm-module';
import {
  DELIVERY_ORDER_TYPE,
  GUEST_USER,
  ROUTE_CHECKOUT,
  ROUTE_HOME,
  REACT_APP_CLOUD_FRONT
} from '../../constants';
import useAddToOrder from '../../hooks/useAddToOrder';
import useGetCustomerPlacedOrders from '../../react-query-hooks/useGetCustomerPlacedOrders';
import { getUser, isGuestUser } from '../../helpers/helperMethods';
import useCheckMobileScreen from '../../hooks/useCheckMobileScreen';
import OrderDetailsMobile from '../../containers/order/OrderDetails/OrderDetailsMobile';
import { Toast_Func } from '../../helpers/toast.helper';
import AddressConfirmationForUser from '../Forms/AddressConfimationForUser';
import useAddAddress from '../../react-query-hooks/useAddAddress';
import PopUpModel from '../../components/Footer/PopUpModel';
import useKeypress from '../../hooks/useKeypress';
import { ROUTE_REWARDS_REDEEM } from '../../constants';
import { NavlinkModel } from '../../models/navlink.model';
import { Helmet } from 'react-helmet';
import { getStructuredItemList } from '../../helpers/scripts/seoScript';
import { cartSubTotal } from '../../helpers/cartHelperMethods';
import HeaderTop from './HeaderTop';
import {
  CartBagIcon,
  DeliveryIcon,
  LocationFilledIcon,
  LocationOutlineIcon,
  DeliveryIconMobile,
  CartBagItemAdded,
  UserIcon,
} from '../../images/svgIcons/svg';
import {
  startLocationFlowModalClose,
} from '../../redux/slices/itemSlice';
import useKioskLogin from '../../hooks/useKioskLogin';
import useDeepLinkRedirection from '../../hooks/useDeepLinkRedirection';
import OrderTrackBar from './OrderTrackBar';
import { specificNewMobileDesignPage } from '../utils';
import useTrackBarVisibility from '../../hooks/useTrackBarVisibility';
import { useIsDesignV2 } from '../../hooks/useIsDesignV2';
import PencilBrazeBanner from './PencilBrazeBanner';
import TopBrazeBannerMobile from './TopBrazeBannerMobile';
import MenuCategoryDropdown from '../MenuCategoryDropdown/MenuCategoryDropdown';
import { PULSE_VIEW_ID, trackPulseView } from '../../analytics/pulseViewIds';
import { trackChangeLocationClick } from '../../analytics/pulseChangeLocationClick';
import PulseTapCartIconTracker from '../../analytics/PulseTapCartIconTracker';
import { setTapCartIconCheckoutOrigin, armTapCartIconClick } from '../../analytics/pulseTapCartIcon';

const Header: React.FunctionComponent = () => {
  const isItMobile = useCheckMobileScreen();
  const location = useLocation();
  const isDesignV2 = useIsDesignV2();

  const showNewHeader = isItMobile;
  const shouldShowLiveTrackerBarOnThisRoute = useTrackBarVisibility();

  const { locationInfo } = useStoreLocation();
  const { removeKioskLoginSession } = useKioskLogin();
  const [changeTo, setChangeTo] = useState(CONSTANT.PICK_UP_ORDER_TYPE);

  const history = useNavigate();
  let authInfo = getUser();
  
  const Cart = useAppSelector((state) => state.cart);
  const isAddPointSelected = useAppSelector((state) => state.Items.extras.isAddPointSelected);
  const rewardsHeaderClickCategory = useAppSelector(
    (state) => state.Items.extras.rewardsHeaderClickCategory
  );
  const {
    showLocationModal,
    setShowLocationModal,
    setShowCartModal,
    showCartModal,
  } = useDeepLinkRedirection();
  const dispatch = useAppDispatch();
  const [openOrderModal, setOpenOrderModal] = useState(false);

  useEffect(() => {
    if (showCartModal) {
      setShow(true);
    }
    setOpenOrderModal(showLocationModal);
  }, [showCartModal, showLocationModal]);

  let show = Cart.showCart;
  const setShow = (state) => {
    dispatch(setShowCart(state));
  };
  const user = getUser();
  const userId = user.id ?? '';
  const userType = user.type ?? '';
  const authUserId = userType !== GUEST_USER ? authInfo?.id : null;

  const { addToOrder } = useAddToOrder();
  const [stickyClass, setStickyClass] = React.useState('remove-sticky');
  const navLinksArray: NavlinkModel[] = [
    {
      text: 'HOME',
      link: '/',
      alternateURL: { exist: true, link: '/' },
    },
    {
      text: 'ORDER',
      link: CONSTANT.ROUTE_MENU,
      alternateURL: { exist: true, link: CONSTANT.ROUTE_MENU },
    },
    {
      text: 'REWARDS',
      link: CONSTANT.ROUTE_FAQ,
      alternateURL: { exist: true, link: ROUTE_REWARDS_REDEEM },
    },
    {
      text: 'OUR KITCHEN',
      link: CONSTANT.ROUTE_OUR_KITCHEN,
      alternateURL: { exist: false, link: null },
    },
    {
      text: 'FUNDRAISERS',
      link: CONSTANT.ROUTE_FUNDRAISING,
      alternateURL: { exist: false, link: null },
      mobileOnly: true
    },
    {
      link: CONSTANT.ROUTE_TALK_TO_US,
      text: "CONTACT US",
      alternateURL: { exist: false, link: null },
      mobileOnly: true
    },
    {
      link: CONSTANT.TERMS_ROUTE,
      text: "TERMS & CONDITIONS",
      alternateURL: { exist: false, link: null },
      mobileOnly: true
    },
    {
      link: CONSTANT.PRIVACY_POLICY_ROUTE,
      text: "PRIVACY POLICY",
      alternateURL: { exist: false, link: null },
      mobileOnly: true
    },
  ];

  const [showLocationPopup, setLocationPopup] = useState(false);
  const [showLiveTracker, setShowLiveTracker] = useState(false);

  const [addressConfirmationModal, setAddressConfirmationModal] = useState<{
    showModal: boolean;
    showCart: boolean;
  }>({ showModal: false, showCart: false });
  const { mutateAsync: addAddress, isLoading: isAddingAddress } =
    useAddAddress();
  const [isActiveOrders, setIsActiveOrders] = useState<boolean>(true);
  const [onScrollNavHide, setOnScrollNavHide] = useState(false);
  const [onScrollNavPrevPos, setOnScrollNavPrevPos] = useState(100);
  const orderType = useAppSelector((state) => state.cart?.orderType || CONSTANT.PICK_UP_ORDER_TYPE);

  const handleClose = () => {
    setShow(false);
    setShowCartModal(false);
  };
  const handleShow = () => {
    armTapCartIconClick();
    if (location.pathname.includes(ROUTE_CHECKOUT)) {
      setTapCartIconCheckoutOrigin(location.pathname);
      history(CONSTANT.ROUTE_MENU);
      setShow(true);
      return;
    }
    if (!Cart.isOrderTypeSelected) {
      setOpenOrderModal(true);
    } else {
      if (verifyAddress())
        setAddressConfirmationModal({ showModal: true, showCart: true });
      else setShow(true);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isScrollingDown = currentScrollPos > onScrollNavPrevPos;
      setOnScrollNavHide(isScrollingDown);
      const isAtTop = currentScrollPos === 10;
      setOnScrollNavPrevPos(currentScrollPos);
      if (isAtTop) {
        setOnScrollNavHide(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [onScrollNavPrevPos]);

  useEffect(() => {
    if (!isGuestUser(authInfo)) {
      TagManager.dataLayer({ dataLayer: { user_email: user?.email } });
    } else {
      TagManager.dataLayer({ dataLayer: { user_email: null } });
    }
  }, [user.id]);

  useEffect(() => {
    const handleLocationButtonGlobal = (event: CustomEvent) => {
      trackChangeLocationClick({
        pathname: window.location.pathname,
        rewardsCategory: rewardsHeaderClickCategory,
        label: locationInfo?.selectedStore?.name || null,
      });
      const changeTo = event.detail;
      if (verifyAddress()) {
        setAddressConfirmationModal({ showModal: true, showCart: false });
        return;
      }
      if(changeTo === DELIVERY_ORDER_TYPE) {
        setChangeTo(DELIVERY_ORDER_TYPE);
      }else if(changeTo === CONSTANT.PICK_UP_ORDER_TYPE) {
        setChangeTo(CONSTANT.PICK_UP_ORDER_TYPE);
      }
      setOpenOrderModal(true);
    };
  
    window.addEventListener(
      'openLocationSelectionModal',
      handleLocationButtonGlobal as EventListener
    );
  
    return () => {
      window.removeEventListener(
        'openLocationSelectionModal',
        handleLocationButtonGlobal as EventListener
      );
    };
  }, []);

  const closeOpenOrderModal = () => {
    setOpenOrderModal(false);
    setShowLocationModal(false);
    dispatch(startLocationFlowModalClose());
  };

  const closeLocationPopup = () => setLocationPopup(false);
  
  const handleLocationButton = () => {
    trackChangeLocationClick({
      pathname: location.pathname,
      rewardsCategory: rewardsHeaderClickCategory,
      label: locationInfo?.selectedStore?.name || null,
    });
    if (verifyAddress()) {
      setAddressConfirmationModal({ showModal: true, showCart: false });
      return;
    }
    if(orderType === CONSTANT.PICK_UP_ORDER_TYPE) {
      setChangeTo(CONSTANT.PICK_UP_ORDER_TYPE);
    }else if(orderType === CONSTANT.DELIVERY_ORDER_TYPE) {
      setChangeTo(CONSTANT.DELIVERY_ORDER_TYPE);
    }
    setOpenOrderModal(true);
  };

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 1) {
      setStickyClass('add-sticky');
    } else {
      setStickyClass('remove-sticky');
    }
  };

  useEffect(() => {
    !showNewHeader && window.addEventListener('scroll', handleScroll);

    return () => {
      if(!showNewHeader){
        window.removeEventListener('scroll', handleScroll);
        setStickyClass("remove-sticky")
      } 
    };
  }, [showNewHeader]);

  const verifyAddress = () => {
    return (
      Cart.orderType === DELIVERY_ORDER_TYPE &&
      authInfo.type !== GUEST_USER &&
      Cart?.orderDetails?.delivery_address?.isGuestAddress
    );
  };

  const closeAddressConfirmationModal = () => {
    if (addressConfirmationModal.showCart) dispatch(setShowCart(true));
    setAddressConfirmationModal({ showCart: false, showModal: false });
  };
  const {
    refetch: refetchGetCustomerPlacedOrders,
    data: { data: placedOrders = [] } = [],
    isFetching: isFetchingPlacedOrders,
  } = useGetCustomerPlacedOrders({
    userId: authInfo?.id,
    userType: authInfo?.type,
  });
  useEffect(() => {
    if (authInfo && authInfo?.id && authInfo?.access_token) {
      refetchGetCustomerPlacedOrders();
    }
  }, [authInfo?.id]);
  const [orderNo, setOrderNo] = useState<number>(null);
  const orderIds = placedOrders?.map((order) => order.id);
  const state = location.state as { from: string };
  if (state?.from === CONSTANT.HISTORY_STATE_FROM_PLACED_ORDER)
    refetchGetCustomerPlacedOrders();
  const isPublicTrackingRoute = location.pathname.includes(
    CONSTANT.ROUTE_ORDER_TRACKING
  );

  const handleCloseLiveTracker = () => {
    setShowLiveTracker(false);
    setOrderNo(null);
  };
  const handleShowLiveTracker = () => {
    refetchGetCustomerPlacedOrders();
    setShowLiveTracker(true);
  };

  useEffect(() => {
    if (!showLiveTracker) return;
    trackPulseView(PULSE_VIEW_ID.ORDER_TRACKING_MODAL, {
      page_path: location.pathname,
    });
  }, [showLiveTracker, location.pathname]);

  const handleMobileOrderBackward = () => {
    setOrderNo(null);
    refetchGetCustomerPlacedOrders();
  };

  if (!placedOrders?.length && showLiveTracker) {
    Toast_Func({ status: false, message: 'No Order Found' });
    handleCloseLiveTracker();
  }

  const locationLabel = () => {
    if (Cart.isOrderTypeSelected) {
      return Cart.orderType === DELIVERY_ORDER_TYPE ? (
        <>
          {' '}
          {isItMobile ? (
            <>
              {' '}
              <span className={`${styleClasses.borderBottomLocation}`}>
                {' '}
                Delivery
              </span>{' '}
              <DeliveryIconMobile />{' '}
            </>
          ) : (
            <>
              <DeliveryIcon />
              <span className={`${styleClasses.borderBottomLocation}`}>
                {' '}
                Delivery
              </span>
            </>
          )}{' '}
        </>
      ) : (
        <>
          {isItMobile ? (
            <>
              <span className={`${styleClasses.borderBottomLocation}`}>
                {' '}
                {locationInfo?.selectedStore?.name}{' '}
              </span>
              <LocationFilledIcon />
            </>
          ) : (
            <>
              <LocationFilledIcon />
              <span className={`${styleClasses.borderBottomLocation}`}>
                {' '}
                {locationInfo?.selectedStore?.name}{' '}
              </span>
            </>
          )}
        </>
      );
    } else
      return (
        <div>
          {isItMobile ? (
            <>
              <span className={`${styleClasses.borderBottomLocation} `}>
                {' '}
                Locations{' '}
              </span>{' '}
              <LocationOutlineIcon />
            </>
          ) : (
            <>
              <LocationOutlineIcon />
              <span className={`${styleClasses.borderBottomLocation}`}>
                {' '}
                find a cafe zupas{' '}
              </span>{' '}
            </>
          )}{' '}
        </div>
      );
  };

  useKeypress('Escape', () => {
    setShowPopupModal(false);
  });

  const loyaltyRedirectionLink = (item) => {
    return userType === CONSTANT.GUEST_USER || user?.logged_out
      ? item.link
      : item.alternateURL.exist
      ? item.alternateURL.link
      : item.link;
  };
  const [showPopupModal, setShowPopupModal] = useState(false);
  const handleClosePopupModal = () => setShowPopupModal(false);
  const showLoyaltyBanner =
    process.env.REACT_APP_SHOW_LOYALTY_BANNER === 'true' ? true : false

  const shouldShowLiveTracker =
  !isFetchingPlacedOrders &&
  placedOrders?.length &&
  !isPublicTrackingRoute &&
  isActiveOrders && shouldShowLiveTrackerBarOnThisRoute && !isAddPointSelected;

  return (
    <>
      <Helmet>
        <script>
          {`            
             gtag('set', { 'user_id': ${authUserId || null} } );
              (function() {
                const cartButton = document.getElementById("cart_button");
                if (cartButton) {
                  cartButton.addEventListener("click", function () {
                          gtag("event", "view_cart", {
                            user_id: ${authUserId || null},
                            currency: "USD",
                            value: ${cartSubTotal(Cart?.items)},
                            items: ${JSON.stringify(
                              getStructuredItemList(
                                Cart?.items,
                                locationInfo?.selectedStore?.id
                              )
                            )}
                        });
                  });
                }
              })();   
            `}
        </script>
      </Helmet>

      <nav
        className={`${styleClasses.headerScrollAnimation}  ${
          onScrollNavHide ? "onScrollHeaderHide" : "onScrollHeaderVisible"
        } ${styleClasses.navContainer}`}
      >
        <div
          className={`${styleClasses.wrapper_tracking_bar} wrapper_tracking_bar_app nav-menu-container-wrap `}
          id="header_wrap"
        >
          <Container
            id="header_container"
            fluid
            className={`${styleClasses.nav_wrapper_main_menu} ${stickyClass} ${styleClasses.fixed} nav-wrapper-mob`}
          >
            
            {isItMobile ? <TopBrazeBannerMobile /> : <PencilBrazeBanner />}
            <div className="px-4"></div>
            <Row className={styleClasses.header_row}>
              <Col
                xs="12"
                className={`${styleClasses.header_logo_wrap} d-flex justify-content-between flex-md-column`}
              >
                {/* Mene Links Wrap */}

                {!isItMobile ? (
                  <div className={`${styleClasses.mainHeaderWrapper} px-4 `}>
                    {shouldShowLiveTracker ? (
                      <OrderTrackBar
                        handleShowLiveTracker={handleShowLiveTracker}
                      />
                    ) : (
                      ""
                    )}
                    <div className="row">
                      <div className="col-lg-5 col-md-3">
                        <HeaderTop
                          locationLabel={locationLabel}
                          handleLocationButton={handleLocationButton}
                          userType={userType}
                          shouldShowLiveTracker={shouldShowLiveTracker}
                          handleShowLiveTracker={handleShowLiveTracker}
                        />
                      </div>
                      <a
                        className={`${styleClasses.logo} col-md-2 col-lg-2`}
                        href={ROUTE_HOME}
                      >
                        <Image
                          className="sticky-logo"
                          source={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/logo.png`}
                          alt="sticky logo"
                        />
                      </a>
                      <div
                        className={`d-flex align-items-center justify-content-end col-lg-5 col-md-7 ${styleClasses.headerRight}`}
                      >
                        <button
                          type="button"
                          className={`${
                            styleClasses.locationNavSection +
                            " " +
                            (Cart.orderType === DELIVERY_ORDER_TYPE
                              ? styleClasses.online_location_icon
                              : "")
                          } d-flex justify-content-center align-items-center`}
                          data-testid="location-selectButton"
                          onClick={handleLocationButton}
                        >
                          {locationLabel()}
                        </button>
                        {userType !== CONSTANT.GUEST_USER ? (
                          <UserName />
                        ) : (
                          <SignUpButton />
                        )}
                        <button
                          type="button"
                          className={`${styleClasses.addToCartBtn} font-Vcf d-flex align-items-end justify-content-center clr-dark-blue`}
                          onClick={handleShow}
                          id={"cart_button"}
                        >
                          {Cart.items?.length ? (
                            <CartBagItemAdded />
                          ) : (
                            <CartBagIcon />
                          )}

                          <span
                            className={Cart.items?.length && "clr-white-clr "}
                          >
                            {Cart.items?.length}
                          </span>
                        </button>
                      </div>
                      {/* </div> */}
                    </div>

                    <div className={styleClasses.headerInnerDiv}>
                      <ul className="mb-0 ps-0 d-flex align-items-center w-100 justify-content-between">
                        {navLinksArray.filter(item => !item?.mobileOnly).map((item, i) => {
                          if (item.link === CONSTANT.ROUTE_MENU) {
                            return (
                              <MenuCategoryDropdown
                                key={i}
                                label="MENU"
                                className={`${styleClasses.headerNavLinks} header-menu-font ${
                                  location.pathname.startsWith(CONSTANT.ROUTE_MENU)
                                    ? styleClasses.activeLink
                                    : ""
                                }`}
                              />
                            );
                          }
                          return (
                            <NavLink
                              key={i}
                              to={"" + loyaltyRedirectionLink(item)}
                              className={({ isActive }) =>
                                `${styleClasses.headerNavLinks} header-menu-font` +
                                (isActive ? ` ${styleClasses.activeLink}` : "")
                              }
                            >
                              {item.text}
                            </NavLink>
                          );
                        })}
                        <a
                          className={`${styleClasses.headerNavLinks} header-menu-font`}
                          href={CONSTANT.CATERING_CAFE_ZUPAS_URL}
                        >
                          {CONSTANT.CATERING_CAFE_ZUPAS}
                        </a>
                        <NavLink
                          to={CONSTANT.ROUTE_FUNDRAISING}
                          className={({ isActive }) =>
                            `${styleClasses.headerNavLinks} header-menu-font` +
                            (isActive ? ` ${styleClasses.activeLink}` : "")
                          }
                        >
                          FUNDRAISERS
                        </NavLink>
                        <NavLink
                          to={CONSTANT.ROUTE_CAREERS}
                          className={({ isActive }) =>
                            `${styleClasses.headerNavLinks} header-menu-font` +
                            (isActive ? ` ${styleClasses.activeLink}` : "")
                          }
                        >
                          Careers
                        </NavLink>
                      </ul>
                    </div>
                  </div>
                ) : (
                  <div className="w-100">
                    {shouldShowLiveTracker ? (
                      <OrderTrackBar
                        handleShowLiveTracker={handleShowLiveTracker}
                      />
                    ) : (
                      ""
                    )}

                    {!showNewHeader && (
                      <HeaderTop
                        locationLabel={locationLabel}
                        handleLocationButton={handleLocationButton}
                        userType={userType}
                        shouldShowLiveTracker={shouldShowLiveTracker}
                        handleShowLiveTracker={handleShowLiveTracker}
                      />
                    )}

                    {!isAddPointSelected &&<div
                      className={`${styleClasses.header_menu_Wrapper} ${styleClasses.mainHeaderWrapper} d-flex justify-content-between align-items-center w-100  `}
                    >
                      <NavbarComponent
                        isHeader={true}
                        Navlinks={navLinksArray}
                        classes="clr-lt-black header-menu-font"
                        expand="md"
                        userId={userId}
                        shouldShowLiveTracker={shouldShowLiveTracker}
                        showLoyaltyBanner={showLoyaltyBanner}
                        ignorePopUpIdCheck={true}
                      ></NavbarComponent>
                      {showNewHeader &&
                      locationInfo?.selectedStore ? (
                        <div
                          className="px-2 pointer-event"
                          onClick={handleLocationButton}
                        >
                          <p className="font-Visby-cf fw-bold f-s14 mb-0">
                            {Cart.orderType === CONSTANT.PICK_UP_ORDER_TYPE
                              ? "PICK-UP LOCATION"
                              : "DELIVERY AT"}
                          </p>
                          <p
                            className={`font-Visby-cf f-s14 mb-0 clr-dark-blue ${styleClasses.newHomeLocation} `}
                          >
                            {(() => {
                              if (
                                Cart.orderType === CONSTANT.PICK_UP_ORDER_TYPE
                              ) {
                                const pickupParts = [
                                  locationInfo?.selectedStore?.address,
                                  locationInfo?.selectedStore?.name,
                                ].filter(Boolean);
                                return pickupParts.join(", ");
                              }
                              const d =
                                Cart.orderDetails?.delivery_address || {};
                              const deliveryParts = [
                                d.street,
                                d.apartment_no,
                                d.city,
                                d.state,
                                d.zipcode,
                              ].filter(
                                (part) =>
                                  part &&
                                  part !== "null" &&
                                  part !== "undefined"
                              );
                              return deliveryParts.join(", ");
                            })()}
                          </p>
                        </div>
                      ) : (
                        <a
                          className={styleClasses.logo}
                          href={showNewHeader ? "#" : ROUTE_HOME}
                          aria-label="CZ Logo"
                          onClick={() => {
                            if (!showNewHeader) return;
                            handleLocationButton();
                          }}
                          data-testid="location-selectButton-formobile"
                        >
                          <Image
                            className="sticky-logo"
                            source={`${REACT_APP_CLOUD_FRONT}/images/NewHomePage/logo.png`}
                            alt="sticky logo"
                          />
                        </a>
                      )}
                      <div
                        className={`d-flex align-items-center  ${styleClasses.headerRight}`}
                      >
                        {userType !== CONSTANT.GUEST_USER ? (
                          <UserName />
                        ) : (
                          <SignUpButton />
                        )}
                        <Link
                          to={
                            userType === CONSTANT.GUEST_USER
                              ? CONSTANT.ROUTE_LOGIN
                              : CONSTANT.ROUTE_PROFILE_DETAILS
                          }
                          data-testid="signin-button-for-mobile"
                          onClick={() => {
                            dispatch(setShowCart(false));
                          }}
                        >
                          <UserIcon />
                        </Link>
                        <button
                          type="button"
                          className={`${styleClasses.addToCartBtn} font-Vcf d-flex align-items-end justify-content-center clr-dark-blue`}
                          onClick={handleShow}
                          id={"cart_button"}
                        >
                          {Cart.items?.length ? (
                            <CartBagItemAdded />
                          ) : (
                            <CartBagIcon />
                          )}

                          <span
                            className={Cart.items?.length && "clr-white-clr"}
                          >
                            {Cart.items?.length}
                          </span>
                        </button>
                      </div>
                    </div>}
                  </div>
                )}
              </Col>
            </Row>
          </Container>
          {show ? (
            <>
              <PulseTapCartIconTracker isCartOpen={show} />
              <CartModal
                addToOrder={addToOrder}
                showModal={show}
                closeModal={handleClose}
              />
            </>
          ) : null}
          {/* New Payment Method Modal */}
          <LocationInfoModal
            showModal={showLocationPopup}
            closeModal={closeLocationPopup}
          />
          <Modal
            show={openOrderModal}
            centered
            className="theme-modal-style app_container_wrap  border-radius-15 px-5 order_type_modal"
            onHide={closeOpenOrderModal}
            size="sm"
          >
            <Modal.Header className="x-4 justify-content-center">
              <button
                type="button"
                className="btn modal-close-button pe-0 sm-blue-icon"
                onClick={closeOpenOrderModal}
              >
                Close
              </button>
            </Modal.Header>
            <Modal.Body>
              <OrderType
                itemPath={
                  showNewHeader
                    ? {
                        pathname: `${CONSTANT.ROUTE_MENU}`,
                        search: "",
                        state: {},
                      }
                    : null
                }
                handleOrderTypeModal={closeOpenOrderModal}
                changeToDelivery={changeTo === CONSTANT.DELIVERY_ORDER_TYPE}
                changeToPickup={changeTo === CONSTANT.PICK_UP_ORDER_TYPE}
                modalSource="header"
              />
            </Modal.Body>
          </Modal>
          <Modal
            show={addressConfirmationModal.showModal}
            centered
            className="theme-modal-style app_container_wrap  border-radius-15 px-5 order_type_modal"
            onHide={() => {
              !isAddingAddress &&
                setAddressConfirmationModal({
                  showCart: false,
                  showModal: false,
                });
            }}
            size="sm"
          >
            <Modal.Header className="x-4 justify-content-center">
              <button
                type="button"
                className="btn modal-close-button pe-0 sm-blue-icon"
                onClick={() => {
                  !isAddingAddress &&
                    setAddressConfirmationModal({
                      showCart: false,
                      showModal: false,
                    });
                }}
              >
                Close
              </button>
            </Modal.Header>
            <Modal.Body>
              <AddressConfirmationForUser
                closeModal={closeAddressConfirmationModal}
                addAddress={addAddress}
                isAddingAddress={isAddingAddress}
              />
            </Modal.Body>
          </Modal>

          <div className="LiveTracking">
            <Modal
              show={showLiveTracker}
              centered
              className="live_tracking_modal theme-modal-style app_container_wrap border-radius-15 px-5 full-modal-ipad"
              onHide={handleCloseLiveTracker}
              size="xl"
            >
              <Modal.Header className="x-4 justify-content-center">
                <button
                  type="button"
                  className="btn modal-close-button pe-0"
                  onClick={handleCloseLiveTracker}
                >
                  Close
                </button>
              </Modal.Header>
              <Modal.Body>
                {isItMobile && orderNo === null ? (
                  <>
                    <OrderDetailsMobile
                      setOrderNo={setOrderNo}
                      orders={placedOrders}
                      isFetchingOrders={isFetchingPlacedOrders}
                    />
                  </>
                ) : (
                  <Livetracking
                    selectedOrderNo={orderNo}
                    handleMobileOrderBackward={handleMobileOrderBackward}
                    orderIds={orderIds}
                    handleClose={handleCloseLiveTracker}
                    isFetchingOrders={isFetchingPlacedOrders}
                    titlespace={styleClasses.order_detail_live}
                    setIsActiveOrders={setIsActiveOrders}
                  />
                )}
              </Modal.Body>
            </Modal>
          </div>

          <Row>
            <Col xs="12" sm="12" md="6">
              <PopUpModel
                showPopup={showPopupModal}
                closePopup={handleClosePopupModal}
              />
            </Col>
          </Row>
        </div>
      </nav>
    </>
  );
};

export default Header;